import { render } from "./CustomTableList.vue?vue&type=template&id=2f54a061&ts=true"
import script from "./CustomTableList.vue?vue&type=script&lang=ts"
export * from "./CustomTableList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__